module.exports = __webpack_public_path__ + "static/media/Black Widow 2.b4be980d.jpg";